
import React, { useEffect, useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Box,
  Typography,
  ButtonBase,
  Avatar,
  Stack,
  Divider,
  useTheme,
  useMediaQuery,
  Button,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

import DashboardIcon from '@mui/icons-material/Dashboard';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PrintIcon from '@mui/icons-material/Print';

import GroupIcon from '@mui/icons-material/Group';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import BarChartIcon from '@mui/icons-material/BarChart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CategoryIcon from '@mui/icons-material/Category';
import AddIcon from '@mui/icons-material/Add';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import TableRowsIcon from '@mui/icons-material/TableRows';
import TableViewIcon from '@mui/icons-material/TableView';
import dashboard from "../../assets/Dashboard.svg";
import sales from "../../assets/sales.svg";
import itemManage from "../../assets/itemManage.svg";
import offerManage from "../../assets/offers.png";
import userManage from "../../assets/userManage.svg";
import franchiseManage from "../../assets/franchiseManage.svg";
import orderTrack from "../../assets/orderManage.svg";
import stocksmanager from "../../assets/stockmanage.svg";
import Bell from "../../assets/Bell.svg";
import Tracks from "../../assets/track.svg";
import BKLogo from "../../assets/trans logo bk (1) 1.svg";


import BytingKornerLogo from '../../assets/Byting_Korner_logo.png'; // Replace with your path
import ChatSupportIcon from '../../assets/chat-support.svg'; // Replace with your path
import EndDayPopup from '../EODPOS/EodPOS';

const drawerWidth = 265;
// const drawerWidth = 320;
const SidebarPOS = ({ mobileOpen, handleDrawerToggle }) => {
  const navigate = useNavigate();
  const [showEndPopup, setShowEndPopup] = useState(false);

  const location = useLocation();
  const [hoveredPath, setHoveredPath] = useState(null);



  const [openSection, setOpenSection] = useState(null);

  useEffect(() => {
  console.log("📍 Sidebar location changed:", location.pathname);

  if (location.pathname.startsWith("/manage-stock")) {
    console.log("✅ Opening 'stocks' section");
    setOpenSection("stocks");
  }

  if (location.pathname.startsWith("/order-tracker")) {
    console.log("✅ Opening 'track' section");
    setOpenSection("track");
  }
}, [location.pathname]);


const toggleSection = (section) => {
  setOpenSection(prev => (prev === section ? null : section));
};

  const theme = useTheme();

  const isActive = (path) => location.pathname === path;

  const menuItemStyle = (path) => ({
    backgroundColor: isActive(path) ? '#FFD33D' : 'transparent',
    color: isActive(path) ? 'black' : '#A1A1A1',
    borderRadius: '8px',
    cursor: 'pointer',
    px: 2,
    '&:hover': {
      backgroundColor: '#FFEDB1',
      color: 'black',
    },
  });

const iconStyle = (path, isHovered = false) => {
  return {
    minWidth: 32,
    // mr: 1,
    '& img': {
      width: 20,
      height: 20,
      filter: isHovered ? 'brightness(0) saturate(100%)' : 'none',
      transition: 'filter 0.3s',
    },
  };
};

const isSectionActive = (prefix) => location.pathname.startsWith(prefix);

const user = JSON.parse(localStorage.getItem("userDetails")) || {};
const userRole = user.role_name || "Super Admin";


const HoverIcon = ({ src, alt, isHovered, isActive }) => (
  <Box
    component="span"
    sx={{
      width: 20,
      height: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        filter: isHovered || isActive ? 'brightness(0) saturate(100%)' : 'none',
        transition: 'filter 0.3s',
      },
    }}
  >
    <img src={src} alt={alt} />
  </Box>
);




  const handleNavigate = (path) => {
    navigate(path);
    if (handleDrawerToggle) {
      handleDrawerToggle();
    }
  };

     const supportItem = {
  text: 'Support',
  subtitle: 'Answers here',
  icon: <img src={ChatSupportIcon} alt="Chat Support" style={{ width: '24px', height: '24px' }} />,
  path: '/support',
};



  const drawerContent = (
    <>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 3 }}>
  <Box
    component="img"
    src={BKLogo}
    alt="Byting Korner Logo"
    sx={{
      width: 48,
      height: 48,
      objectFit: 'contain',
    }}
  />

  <Box>
    <Typography
      variant="h6"
      sx={{
        fontWeight: 600,
        fontSize: '1rem',
        color: '#fff',
        lineHeight: 1.2,
      }}
    >
      Byting Korner
    </Typography>
    <Typography
      variant="body2"
      sx={{
        color: '#A1A1A1',
        fontSize: '0.75rem',
        fontWeight: 400,
      }}
    >
      {userRole}
    </Typography>
  </Box>
</Box>



      <List>
        <Box sx={{ mx: 2, my: 1 }}>
          <Typography sx={{ color: '#888', fontSize: '10px', fontWeight: 600, mb: 1 }}>
            {/* SUPER ADMIN */}
            MAIN
          </Typography>
         <ListItem button onClick={() => handleNavigate('/dashboard-pos')} 
        sx={{
    ...menuItemStyle('/dashboard-pos'),
    display: 'flex',
    alignItems: 'center', // ✅ Vertically align icon and text
  }}onMouseEnter={() => setHoveredPath('/dashboard-pos')}onMouseLeave={() => setHoveredPath(null)}>
<ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
  <HoverIcon src={dashboard} alt="Dashboard" path="/dashboard-pos"  isHovered={hoveredPath === '/dashboard-pos'} isActive={isActive('/dashboard-pos')}  />
</ListItemIcon>

<ListItemText
  primary="Dashboard"
  primaryTypographyProps={{ fontSize: '0.85rem' }}
/>

          </ListItem>
        </Box>




        
        <Box sx={{ mx: 2, my: 1 }}>
          <ListItem
            button
             onClick={() => toggleSection('track')}
              onMouseEnter={() => setHoveredPath('/orders')}onMouseLeave={() => setHoveredPath(null)}
            sx={{
              backgroundColor: location.pathname.startsWith('/order-tracker') ? '#fcd34d' : 'transparent',
              color: isSectionActive('/order-tracker') ? 'black' : '#A1A1A1',
              borderRadius: '8px',
              px: 2,
              cursor: 'pointer',
              '&:hover': { backgroundColor: '#fcd34d', color: '#000' },
            }}
          >
          

            <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
  <HoverIcon src={orderTrack} alt="Orders" path="/orderTrack" isHovered={hoveredPath === '/orderTrack' ||  location.pathname.startsWith('/order-tracker') }/>
</ListItemIcon>

            <ListItemText primary="Orders" primaryTypographyProps={{ fontSize: '0.85rem' }} />
            {openSection === 'track'? <ExpandLess /> : <ExpandMore />}
          </ListItem>
        </Box>

         <Collapse in={openSection === 'track'} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{
  pl: 4,
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 8,
    bottom: 8,
    left: 35,
    width: '2px',
    backgroundColor: '#A1A1A1',
    borderRadius: '2px',
  },
}}>
            {[
              
           
              { text: 'Creat New Order', path: '/order-tracker/order-pos' },
              { text: 'Order Overview', path: '/order-tracker/orderoverview-pos' },
            ].map(({ text, path }) => (
              <Box key={path} sx={{ mx: 2, my: 1 }}>
                <ListItem button onClick={() => handleNavigate(path)} sx={menuItemStyle(path)}>
                  <ListItemText primary={text} primaryTypographyProps={{ fontSize: '0.8rem' }} />
                </ListItem>
              </Box>
            ))}
          </List>
        </Collapse>

   

 


       
         <Box sx={{ mx: 2, my: 1 }}>
          <ListItem
            button
             onClick={() => toggleSection('stocks')}
              onMouseEnter={() => setHoveredPath('/stockmanager')}onMouseLeave={() => setHoveredPath(null)}
            sx={{
              backgroundColor: location.pathname.startsWith('/manage-stock') ? '#fcd34d' : 'transparent',
              color: isSectionActive('/manage-stock') ? 'black' : '#A1A1A1',
              borderRadius: '8px',
              px: 2,
              cursor: 'pointer',
              '&:hover': { backgroundColor: '#fcd34d', color: '#000' },
            }}
          >
            
            <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
  <HoverIcon src={stocksmanager} alt="Stock Manager" path="/managestock" isHovered={hoveredPath === '/managestock'|| location.pathname.startsWith('/manage-stock')} />
</ListItemIcon>

            <ListItemText primary="Stocks" primaryTypographyProps={{ fontSize: '0.85rem' }} />
            {openSection === 'stocks' ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          
        </Box>

         <Collapse in={openSection === 'stocks'} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{
  pl: 4,
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 8,
    bottom: 8,
    left: 35,
    width: '2px',
    backgroundColor: '#A1A1A1',
    borderRadius: '2px',
  },
}}>
            {[
              
           
              { text: 'Stock Management ', path: '/manage-stock/stockmanage-pos' },
          { text: 'Request History ', path: '/manage-stock/requesthistory-pos' },
          { text: 'Current Stock', path: '/manage-stock/current-stockpos' },
            ].map(({ text, path }) => (
              <Box key={path} sx={{ mx: 2, my: 1 }}>
                <ListItem button onClick={() => handleNavigate(path)} sx={menuItemStyle(path)}>
                  <ListItemText primary={text} primaryTypographyProps={{ fontSize: '0.8rem' }} />
                </ListItem>
              </Box>
            ))}
          </List>
        </Collapse>



      {[
          
      
          { text: 'Sales & Reports',  icon: <HoverIcon src={sales} alt="Sales Reports" path="/sales-report-pos" 
          isHovered={hoveredPath === '/sales-report-pos'} isActive={isActive('/sales-report-pos')}  />, path: '/sales-report-pos' },
          {
            text: 'Offers Redeem',
            icon: (
              <HoverIcon
                src={offerManage}
                alt="Offers Redeem"
                path="/offer/redeem"
                isHovered={hoveredPath === '/offer/redeem'}
                isActive={isActive('/offer/redeem')}
              />
            ),
            path: '/offer/redeem',
          },
          {
            text: 'Dynamic Offer',
            icon: (
              <HoverIcon
                src={offerManage}
                alt="Dynamic Offer"
                path="/offer/dynamic-offer"
                isHovered={hoveredPath === '/offer/dynamic-offer'}
                isActive={isActive('/offer/dynamic-offer')}
              />
            ),
            path: '/offer/dynamic-offer',
          },
        
        ].map((item, index) =>
           (
            <Box key={item.text} sx={{ mx: 2, my: 1 }}>
              <ListItem button onClick={() => handleNavigate(item.path)} sx={menuItemStyle(item.path)}>
                <ListItemIcon sx={iconStyle(item.path)}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} primaryTypographyProps={{ fontSize: '0.85rem' }} />
              </ListItem>
            </Box>
          )
        )}
        {[
        {
  text: 'Printer',
  icon: (
    <PrintIcon
      sx={{
        fontSize: 20,
        color:
          hoveredPath === '/printer/printer' || isActive('/printer/printer')
            ? '#000'
            : '#A1A1A1',
      }}
    />
  ),
  path: '/printer/printer',
}
        
        ].map((item, index) =>
           (
            <Box key={item.text} sx={{ mx: 2, my: 1 }}>
              <ListItem button onClick={() => handleNavigate(item.path)} sx={menuItemStyle(item.path)}>
                <ListItemIcon sx={iconStyle(item.path)}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} primaryTypographyProps={{ fontSize: '0.85rem' }} />
              </ListItem>
            </Box>
          )
        )}

      </List>
      


<Box sx={{ p: 2, mt: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
  {/* 🔴 End of the Day Button */}
<Button
  variant="contained"
  fullWidth
  sx={{
    borderRadius: '12px',
    bgcolor: '#e74c3c',
    height: "38px",
    color: '#fff',
    fontWeight: 500,
    fontSize: '0.85rem',
    textTransform: 'none',
    '&:hover': { bgcolor: '#c0392b' },
  }}
  onClick={() => setShowEndPopup(true)}
>
  End of the Day
</Button>

{showEndPopup && (
  <EndDayPopup open={showEndPopup} onClose={() => setShowEndPopup(false)} />
)}

  {/* 🟢 Contact Support Button */}
  {/* <ButtonBase
    sx={{
      width: '100%',
      borderRadius: '12px',
      bgcolor: '#c5f12c',
      color: '#000',
      p: 1.5,
      textAlign: 'left',
      justifyContent: 'flex-start',
      '&:hover': {
        bgcolor: '#bde72a',
      },
    }}
  >
    <Stack direction="row" alignItems="center" spacing={2} width="100%">
      <Avatar sx={{ bgcolor: '#1e1e1e', width: 40, height: 40 }}>
        <img
          src={ChatSupportIcon}
          alt="Chat Support"
          style={{ width: '24px', height: '24px' }}
        />
      </Avatar>
      <Box flexGrow={1}>
        <Typography variant="subtitle1" fontWeight="bold" fontSize="0.85rem">
          Contact Support
        </Typography>
        <Typography variant="body2" fontSize="0.75rem">
          Answers here
        </Typography>
      </Box>
      <ArrowForwardIosIcon fontSize="small" />
    </Stack>
  </ButtonBase> */}
</Box>


    </>
  );

  return (
    <Box component="nav" sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}>
      {/* Drawer logic */}
    <Drawer
  variant="permanent"
  open
  sx={{
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      backgroundColor: '#161B22',
       borderTopRightRadius: '16px',
      color: '#fff',
    },
  }}
>
  {drawerContent}
</Drawer>

    </Box>
  );
};

export default SidebarPOS;

